<template>
  <div class="modal-manage">
    <HonourTimeModal
      :visible="honourVisible && modalVisableQueueKey[0].visibleKey === 'honourVisible'"
      @cancel="() => cancelHandler('honourVisible')"
    />
    <ModalConfirm
      :visible="showConfirmModal && modalVisableQueueKey[0].visibleKey === 'showConfirmModal'"
      @cancel="() => cancelHandler('confirmVisible')"
    />
    <TripartiteModal
      :visible="tripartiteVisible && modalVisableQueueKey[0].visibleKey === 'tripartiteVisible'"
      @cancel="() => cancelHandler('tripartiteVisible')"
      @onStart="handleStart"
      @onQuery="handleQuery"
    />

    <AnnouncementModalItem
      v-for="(item) in announcementDataInfo"
      :key="item.afficheId"
      :dataSource="item"
      :visible="`announcementVisible${item.afficheId}` && modalVisableQueueKey[0] && modalVisableQueueKey[0].visibleKey === `announcementVisible${item.afficheId}`"
      @cancel="() => cancelHandler(`announcementVisible${item.afficheId}`)"
    />
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import jsCookie from 'js-cookie'
  import _ from 'lodash'
  import { $http } from '@/utils/http'
  import host from '@/utils/host'
  import { report } from '@/utils/reportError'
  import { toLogin } from '@/utils/utils'
  import ModalConfirm from './modal'
  import TripartiteModal from './tripartiteModal'
  import HonourTimeModal from './honourTimeModal'
  import AnnouncementModalItem from './announcementModal'

  export default {
    name: "modal-manage",
    components: {
      ModalConfirm,
      TripartiteModal,
      HonourTimeModal,
      AnnouncementModalItem
    },
    data() {
      return {
        modalVisableQueueKey: [{          // 弹框队列控制
          visibleKey: 'honourVisible',
          isFinishKey: 'honourIsFinish'
        }, {                              // 三方进件弹框后面自动插入公告弹框
          visibleKey: 'tripartiteVisible',
          isFinishKey: 'tripartiteIsFinish'
        }, {                              // 公告弹框占位
          visibleKey: 'announcementVisible',
          isFinishKey: 'announcementIsFinish'
        }, {
          visibleKey: 'showConfirmModal',
          isFinishKey: 'confirmIsFinish'
        }],
        // confirm 签订广告投放服务合同弹框
        confirmVisible: true,
        confirmIsFinish: true,
        // 三方进件弹框
        tripartiteVisible: false,
        tripartiteIsFinish: false,
        // 荣耀时刻弹框
        honourVisible:false,
        honourIsFinish: false,
        // 公告管理弹框
        announcementDataInfo: [],   // 公告弹框列表
        // announcementVisible${afficheId}: true,
        announcementIsFinish: false,
        announcementIsEnd: false, // 所有弹框是否完成
      }
    },
    async created() {
      // TODO: 签订广告投放服务合同弹框
      // this.$store.dispatch('queryIsNeedStamp')
      const buzzType = jsCookie.get('buzzType')
      if (+buzzType == 1 || +buzzType == 2) { // pop 和 全球购的走这些弹框
        await Promise.race([
          this.getHonourTimeState(),
          this.getTripartiteState(),
          this.getAnnouncementState(true)
        ])
        this.formateModalQueueKey()
      } else if (+buzzType == 3 || +buzzType == 4) { // 品牌商 和 供应商走公告弹框
        this.honourIsFinish = true
        this.tripartiteIsFinish = true
        await this.getAnnouncementState(true)
        this.formateModalQueueKey()
      }
    },
    computed: {
      ...mapState(['cmsConfig']),
      showConfirmModal() {
        return this.confirmVisible && this.$store.state.showConfirmModal
      }
    },
    methods: {
      ...mapActions('popHome',[
        'setHonourFlag',
        'setAnnouncementFlag'
      ]),
      cancelHandler(key) {
        this[key] = false
        this.formateModalQueueKey()
      },

      async currentShowModal(visibleKey) { // 当前页面展示的弹框
        if (visibleKey === 'honourVisible') { // 当前弹框是荣耀时刻时
          const { honourTimeInfo } = this.$store.state.popHome
          await this.setHonourFlag(honourTimeInfo.honour.id)
        }
        if (/^announcementVisible/.test(visibleKey)) {
          const [, afficheId] = visibleKey.match(/^announcementVisible(\w+)/)
          await this.setAnnouncementFlag({afficheId, operationType: 1})
          await this.getAnnouncementState()
        }
      },
      async formateModalQueueKey() {
        const { visibleKey, isFinishKey } = this.modalVisableQueueKey[0] || {}
        if (isFinishKey && typeof this[isFinishKey] === 'boolean' && !this[isFinishKey]) { // 如果获取信息没完成则等待1秒 还没完成则跳过
          await new Promise(() => {
            setTimeout(() => {
              if (!this[isFinishKey]) {
                this[isFinishKey] = true
              }
              this.formateModalQueueKey()
            }, 1000)
          })
          return
        }
        if(visibleKey && typeof this[visibleKey] === 'boolean' && !this[visibleKey]) { // 已完成并且不需要弹框则从队列弹出
          this.modalVisableQueueKey = this.modalVisableQueueKey.slice(1)
          this.formateModalQueueKey()
          return
        }
        if (visibleKey && isFinishKey && this[visibleKey] && this[isFinishKey]) { // 当前页面展示的弹框
          this.currentShowModal(visibleKey, isFinishKey)
        }
      },

      async getHonourTimeState() {
        await this.$store.dispatch('popHome/getHonourTimeState')
        const { honourTimeInfo } = this.$store.state.popHome
        if (honourTimeInfo.honour && honourTimeInfo.honour.isShow == 0/*之前未弹窗显示过*/) {
          this.honourVisible = true
        }
        this.honourIsFinish = true
      },

      async getAnnouncementState(init) {
        if (init) { // 初始化时将公告弹框插入到 三方进件后面
          const { data } = await this.getAnnouncementData()
          const queueArr = data.map(item => {
            this[`announcementVisible${item.afficheId}`] = true
            return {visibleKey: `announcementVisible${item.afficheId}`, isFinishKey: 'announcementIsFinish'}
          })
          const idx = _.findIndex(this.modalVisableQueueKey, item => item.visibleKey === 'announcementVisible')
          this.modalVisableQueueKey.splice(idx, 1, ...queueArr)
          this.announcementIsFinish = true
        } else {  // 每次弹出时判断 如果announcementIsEnd没有结束则需要继续掉接口获取
          const nextQueue = this.modalVisableQueueKey.slice(1)
          if ((nextQueue.length === 0 || !/^announcementVisible/.test(nextQueue[0].visibleKey)) && !this.announcementIsEnd) { // 当前公告的弹框只剩最后一个了
            this.announcementIsFinish = false
            const { data } = await this.getAnnouncementData()
            const queueArr = data.map(item => {
              this[`announcementVisible${item.afficheId}`] = true
              return {visibleKey: `announcementVisible${item.afficheId}`, isFinishKey: 'announcementIsFinish'}
            })
            this.modalVisableQueueKey.splice(1, 0, ...queueArr)
            this.announcementIsFinish = true
          }
        }
      },
      async getAnnouncementData() {
        const url = `${host.hbpnotice}/hbp-notice/hbppc/outnet/affiche/queryAlertList.do`
        const res = await $http.get(`${url}?limit=5`)
        if (res && res.code * 1 === 0) {
          if (!res.data) res.data = []
          const { count, data } = res
          this.announcementDataInfo.push(...data)
          if (count <= data.length ) this.announcementIsEnd = true
          return res
        } else if (res.code * 1 === 1024) {
          toLogin()
        } else {
          !res.report && report({
              url,
              res,
              msg: res.msg || '工作台POP获取公告弹框接口异常'
          })
        }

      },
      async getTripartiteState() {
        const params = this.getBizInfo()
        if (!params) {
          this.tripartiteIsFinish = true
          return
        }
        await this.$store.dispatch('popHome/getTripartiteState', params)
        const { tripartiteState } = this.$store.state.popHome
        if (typeof tripartiteState == 'number' && tripartiteState !== 2) {
          this.tripartiteVisible = true
        }
        this.tripartiteIsFinish = true
      },

      getBizInfo() {
        let buzzType = jsCookie.get('buzzType')
        const BillBusinessType = {
          1: 'POP',
          2: 'POP',
          3: '',
          4: '',
          5: 'CZJ', // yuer暂时用成长加
          6: 'CZJ'
        }
        if (+buzzType == 1) {
          const bizType = BillBusinessType[buzzType || '']
          const bizBusinessId = jsCookie.get('parentBuzzId') || jsCookie.get('buzzId')
          return {
            bizType,
            bizBusinessId
          }
        }
        return null
      },
      handleStart() {
        this.tripartiteVisible = false
        this.$emit('menuChange', {link: '//myseller.haiziwang.com/service/tripartiteauth/applyform'})
      },
      handleQuery() {
        this.tripartiteVisible = false
        this.$emit('menuChange', {link: '//myseller.haiziwang.com/service/tripartiteauth/enterprogress'})
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
